@if (hasEnrolmentToken && !tokenExpired) {
  <div>
    <span class="cert" (click)="downloadCert()"></span>
    @if (!item.enrollmentJwt) {
      <span class="qr icon-qr" (click)="showQRCode()"></span>
    }
  </div>
}
@if (hasEnrolmentToken && tokenExpired) {
  <div>
    <span>Enrollment Expired</span>
  </div>
}
@if (!hasEnrolmentToken) {
  <div>
    --
  </div>
}